import * as React from 'react';
import { useSelector } from 'react-redux';
import { EngineRenderers } from '@websky/core/src/renderProps';
import { getOrder } from '@websky/core/src/Checkout/store/order/selectors';
import { getCheckinOrder } from '@websky/core/src/Modules/Checkin/store/order/selectors';
import { ModeContext } from '@websky/core/src/context';
import { Mode } from '@websky/core/src/types';

import PricePartsComponent from '@websky/core/src/PaymentForm/components/PriceParts/PriceParts';
import { getUnpaidGdsServicesCountByRfisc } from './utils';
import { CheckinOrder, CheckinOrderFragment, CheckoutOrderFragment } from '@websky/graphql';

const PriceParts: EngineRenderers['PriceParts'] = props => {
	const mode = React.useContext(ModeContext);
	let additionalServices: Partial<CheckinOrderFragment['additionalServices']> = {};
	let unpaidServiceFeeCount;

	if (mode === Mode.Checkin) {
		additionalServices = useSelector(getCheckinOrder).additionalServices;
		unpaidServiceFeeCount = getUnpaidGdsServicesCountByRfisc(useSelector(getCheckinOrder) as CheckinOrder);
	} else {
		additionalServices = useSelector(getOrder).additionalServices;
		unpaidServiceFeeCount = getUnpaidGdsServicesCountByRfisc(
			(useSelector(getOrder) as unknown) as CheckoutOrderFragment
		);
	}

	const serviceFee = additionalServices.gdsServices?.services?.find(service => service.rfisc === 'RG1');

	const pricesWithServiceFee =
		serviceFee && unpaidServiceFeeCount
			? {
					...props.prices,
					vip: {
						...props.prices.vip,
						amount: props.prices.vip?.amount - unpaidServiceFeeCount * serviceFee.price?.amount
					},
					[serviceFee.name]: { ...props.prices.vip, amount: unpaidServiceFeeCount * serviceFee.price?.amount }
			  }
			: props.prices;

	return <PricePartsComponent {...props} prices={pricesWithServiceFee} />;
};

export default PriceParts;
